import { render, staticRenderFns } from "./DeleteRules.vue?vue&type=template&id=275cbc39&scoped=true"
import script from "./DeleteRules.vue?vue&type=script&lang=js"
export * from "./DeleteRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275cbc39",
  null
  
)

export default component.exports